import { NoteMultipleOutlineIcon } from './NoteMultipleOutlineIcon';

/**
 * author: Austin Andrews
 * id 6294246C-A524-4121-B141-5262D89FFD4D
 * name note-multiple-outline
 * version: 1.7.22
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/note-multiple-outline.svg
 * tags
 */
export const NotesOutlineIcon = NoteMultipleOutlineIcon;
export default NotesOutlineIcon